import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function BookingIntegration() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="booking-integration" ref={containerRef} className="relative min-h-[60vh] flex items-center justify-center py-[var(--space-3xl)] bg-background overflow-hidden">
    <div className="absolute inset-0 opacity-[0.05] bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539566/img/topographic_river_map_texture.png)]" aria-hidden="true" />
    
    <div className="container relative z-10">
      <div className={`max-w-2xl mx-auto text-center space-y-[var(--space-xl)] transition-all duration-[var(--duration-slow)] ease-[var(--ease-out)] ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <div className="space-y-[var(--space-md)]">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground leading-tight">
            Ready to Book Your Adventure?
          </h2>
          <p className="text-lg text-muted-foreground max-w-xl mx-auto">
            Reserve your spot in seconds.
          </p>
        </div>
        <div className="flex flex-col items-center gap-4">
          <a href="https://www.vrbo.com/4997285?dateless=true" target="_blank" rel="noopener noreferrer" className="no-underline">
            <Button size="lg" className="text-lg px-12 py-6 h-auto rounded-xl bg-primary-dark text-white font-semibold shadow-lg hover:shadow-xl hover:-translate-y-1 active:translate-y-0 transition-all duration-150">
              Book Your Experience Now
            </Button>
          </a>
        </div>
      </div>
    </div>
  </section>;
}